/**
 * The runtime is embedded on customer websites, so the environment cannot come from the page.
 * It is derived from the URL the runtime itself was served from, mirroring the platform hosts:
 * app.<domain> → api.<domain>, app-qa.<domain> → api-qa.<domain>, app-dev.<domain> → api-dev.<domain>.
 */
const DEV_API_BASE_URL = 'https://api-dev.agencytext.com';
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]'];
const PUBLIC_PATH = '/contact-captures/public';

const runtimeScriptUrl = () => {
  const current = document.currentScript;
  if (current instanceof HTMLScriptElement && current.src) return current.src;
  const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'));
  return scripts.map(script => script.src).find(src => src.includes('contact-capture')) || '';
};

// Capture this while our bundle executes, before a customer's script calls scan().
const RUNTIME_SCRIPT_URL = runtimeScriptUrl();

export const resolveApiBaseUrl = (scriptUrl: string): string => {
  if (!scriptUrl) return DEV_API_BASE_URL;
  let url: URL | null = null;
  try {
    url = new URL(scriptUrl, window.location.href);
  } catch {
    url = null;
  }
  if (!url) return DEV_API_BASE_URL;
  if (LOCAL_HOSTNAMES.includes(url.hostname)) return DEV_API_BASE_URL;
  if (url.hostname.startsWith('app-local.')) {
    return `http://${url.hostname.replace(/^app-local\./, 'api-local.')}:8080`;
  }
  return `${url.protocol}//${url.hostname.replace(/^app(?=[-.])/, 'api')}`;
};

export const contactCaptureConfigUrl = (captureId: string, scriptUrl = RUNTIME_SCRIPT_URL) =>
  `${resolveApiBaseUrl(scriptUrl)}${PUBLIC_PATH}/${encodeURIComponent(captureId)}`;

export const contactCaptureActionUrl = (configUrl: string, action: 'event' | 'submission'): URL | undefined => {
  try {
    const url = new URL(configUrl, window.location.href);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
    url.pathname = `${url.pathname.replace(/\/$/, '')}/${action}`;
    url.hash = '';
    return url;
  } catch {
    return undefined;
  }
};
